// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 获取公司标签列表
 * @param pram
 * @constructor
 */
export function getTagList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // const data = {
  //   tagName: pram.tagName,
  //   page: pram.page,
  //   limit: pram.limit,
  // };
  return request({
    url: '/admin/emp/tag/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增标签
 * @param pram
 * @constructor
 */
export function addTag(pram) {
  return request({
    url: '/admin/emp/tag/add',
    method: 'POST',
    data: pram
  });
}

/**
 * 更新标签
 * @param pram
 * @constructor
 */
export function updateTag(pram) {
  return request({
    url: '/admin/emp/tag/update',
    method: 'POST',
    data: pram
  });
}

/**
 * 删除标签
 * @param id
 * @constructor
 */
export function deleteTag(id) {
  return request({
    url: "/admin/emp/tag/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 获取标签详情
 * @param {*} id
 * @returns
 */
export function getTagDetail(id) {
  return request({
    url: "/admin/emp/tag/info",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取标签自动补全列表（用于使用人群选择）
 * @param {string} keyword - 搜索关键词
 */
export function getTagAutocomplete(keyword) {
  return request({
    url: '/admin/emp/tag/autocomplete',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}